// Meta tags management plugin for SEO
export default {
  install: (app) => {
    // Inject $meta into Vue instance
    app.config.globalProperties.$meta = {
      // Update page meta tags
      update(options) {
        // Set page title
        if (options.title) {
          document.title = options.title + ' - Real Yunnan Tours';
        }
        
        // Set meta description
        if (options.description) {
          let descriptionMeta = document.querySelector('meta[name="description"]');
          if (descriptionMeta) {
            descriptionMeta.setAttribute('content', options.description);
          } else {
            descriptionMeta = document.createElement('meta');
            descriptionMeta.setAttribute('name', 'description');
            descriptionMeta.setAttribute('content', options.description);
            document.head.appendChild(descriptionMeta);
          }
        }
        
        // Set canonical URL
        const canonicalUrl = options.canonicalUrl || window.location.href.split('?')[0];
        let canonicalLink = document.querySelector('link[rel="canonical"]');
        if (canonicalLink) {
          canonicalLink.setAttribute('href', canonicalUrl);
        } else {
          canonicalLink = document.createElement('link');
          canonicalLink.setAttribute('rel', 'canonical');
          canonicalLink.setAttribute('href', canonicalUrl);
          document.head.appendChild(canonicalLink);
        }
        
        // Set Open Graph tags
        this.updateOpenGraph({
          title: options.title || document.title,
          description: options.description || '',
          image: options.image || '/images/logo.jpg',
          url: canonicalUrl
        });
      },
      
      // Update Open Graph meta tags
      updateOpenGraph(og) {
        const tags = {
          'og:title': og.title,
          'og:description': og.description,
          'og:image': og.image,
          'og:url': og.url,
          'og:type': 'website'
        };
        
        Object.keys(tags).forEach(key => {
          let meta = document.querySelector(`meta[property="${key}"]`);
          const content = tags[key];
          
          if (meta) {
            meta.setAttribute('content', content);
          } else {
            meta = document.createElement('meta');
            meta.setAttribute('property', key);
            meta.setAttribute('content', content);
            document.head.appendChild(meta);
          }
        });
      }
    };
  }
}; 